import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { CheckoutResponse } from '~client/model/checkout-response';
import { ResponseEntity } from '~client/model/response-entity';
import { AssignedOfferGroupPurchaseRequest } from '~client/model/assigned-offer-group-purchase-request';
import { PurchaseResponse } from '~client/model/purchase-response';

/* User APIs pertaining to users purchasing/confirming Yoop from promoters */
export class PromoterPurchaseController extends BaseController {
  /**
   * Validates that the assignment string is valid before the user can accept from a promoter.
   */
  public validateAssignment$(assignmentString: string): Observable<ResponseEntity> {
    return this.get$('/promoter/userPurchase/public/validate', { assignmentString });
  }

  /**
   * Returns checkout information for credit card purchases from promoters.
   */
  public checkout(assignmentString: string, paymentMethodId: number): Promise<CheckoutResponse> {
    return this.get('/promoter/userPurchase/checkout', { assignmentString, paymentMethodId });
  }

  /**
   * Returns checkout information for credit card purchases from promoters.
   */
  public checkoutPublic(assignmentString: string): Promise<CheckoutResponse> {
    return this.get('/promoter/userPurchase/public/checkout', { assignmentString });
  }

  /**
   * Confirms tokens from the client to the current promoter. The payment method ID is null when
   * users pay the promoters directly in cash.
   */
  public purchase$(request: AssignedOfferGroupPurchaseRequest): Observable<ResponseEntity> {
    return this.post$('/promoter/userPurchase/purchase', request);
  }
  public purchase(request: AssignedOfferGroupPurchaseRequest): Promise<PurchaseResponse> {
    return this.post('/promoter/userPurchase/purchase', request);
  }

  /**
   * Declines an offer group made to the user from promoter.
   */
  public decline$(assignmentString: string): Observable<ResponseEntity> {
    return this.get$('/promoter/userPurchase/public/decline', { assignmentString });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/promoter-purchase-controller.ts